
import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'privacy-policy',
    templateUrl: 'privacy-policy.html',
    styleUrl: 'privacy-policy.scss',
    standalone: true,
    imports: [TranslatePipe],
})
export class PrivacyPolicyPage {}
